const initialState = {
  loading: false,
  loadingCmt: false,

  //event
  cmForm: {
    pg: 1,
    pgSz: 10,
    evSeq: "",
  },
  commentList: "",
};

export const INIT = "INIT";
export const init = () => ({
  type: INIT,
});

export const LOADING = "LOADING";
export const loadingAction = (data) => ({
  type: LOADING,
  payload: data,
});

export const INIT_EVENT = "INIT_EVENT";
export const initEventAction = (data) => ({
  type: INIT_EVENT,
  payload: data,
});

export const LOADING_REVIEW = "LOADING_REVIEW";
export const loadingCommentAction = (data) => ({
  type: LOADING_REVIEW,
  payload: data,
});

export const SET_FORM = "SET_FORM";
export const schFormAction = (data) => ({
  type: SET_FORM,
  payload: data,
});
export const LOAD_REVIEW_LIST = "LOAD_REVIEW_LIST";
export const loadCommentListAction = (data) => ({
  type: LOAD_REVIEW_LIST,
  payload: data,
});

export const LOAD_REVIEW_LIST_SUCCESS = "LOAD_REVIEW_LIST_SUCCESS";
export const loadCommentListSuccessAction = (data) => ({
  type: LOAD_REVIEW_LIST_SUCCESS,
  payload: data,
});

export default function reviewReducer(state = initialState, action) {
  const { type, payload, error } = action;
  console.log("payload", payload);
  switch (type) {
    case INIT:
      return {
        ...initialState,
      };
    case SET_FORM:
      return {
        ...state,
        schForm: payload,
      };
    case LOADING:
      return {
        ...state,
        loading: payload,
      };
    case LOADING_REVIEW:
      return {
        ...state,
        loadingCmt: payload,
      };
    case INIT_EVENT:
      return {
        ...initialState,
      };
    case LOAD_REVIEW_LIST:
      return {
        ...state,
        cmForm: payload,
      };
    case LOAD_REVIEW_LIST_SUCCESS:
      return {
        ...state,
        commentList: payload,
      };
    default:
      return state;
  }
}
